import type { GeneratedLesson } from "../types";
import { LessonHeader } from "../result/LessonHeader";
import { BNCCSection } from "../result/BNCCSection";
import { ObjectivesSection } from "../result/ObjectivesSection";
import { LessonPlanSection } from "../result/LessonPlanSection";
import { MaterialsSection } from "../result/MaterialsSection";
import { ActivitiesSection } from "../result/ActivitiesSection";
import { ActionButtons } from "../result/ActionButtons";

interface ResultStepProps {
  generatedLesson: GeneratedLesson;
  onSave: () => void;
  onCopy: () => void;
  onDownload: () => void;
  onRegenerate: () => void;
}

export function ResultStep({
  generatedLesson,
  onSave,
  onCopy,
  onDownload,
  onRegenerate,
}: ResultStepProps) {
  return (
    <div className="space-y-6">
      <LessonHeader lesson={generatedLesson} />
      <BNCCSection lesson={generatedLesson} />
      <ObjectivesSection lesson={generatedLesson} />
      <LessonPlanSection lesson={generatedLesson} />
      <div className="grid md:grid-cols-2 gap-6">
        <MaterialsSection lesson={generatedLesson} />
        <ActivitiesSection lesson={generatedLesson} />
      </div>
      <ActionButtons
        lesson={generatedLesson}
        onSave={onSave}
        onCopy={onCopy}
        onDownload={onDownload}
        onRegenerate={onRegenerate}
      />
    </div>
  );
}
